import Vue from "vue";
import Vuex from "vuex";
import Mobiscroll from "./modules/Mobiscroll.js";
import Appoitments from "./modules/Appoitments.js";
import UserProfile from "./modules/UserProfile.js";
import TableDocs from "./modules/TableDocs.js";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
Vue.use(Vuex);
import moment from "moment";

export default new Vuex.Store({
  state: {
    menuActive: false,
    showPageLoader: false,
    activeUser: Vue.$cookies.get("hmc-active-user") || {},
    connectedCalendars: [],
    activeDoctor: "",
    activeDoctorPolicies: null,
    calendarType: "month",
    user_passport: "",
    surg_patient: Vue.$cookies.get("hmc-surg-patient") || {},
    saveSurgery: {},
    allRooms: localStorage.getItem("hmc-rooms") || [],
    doctorRooms: [],
    isChangeApp: false,
    isShowSearch: false,
    isSurgSchedule: false
  },
  mutations: {
    UPDATE_MENU_STATE(state) {
      state.menuActive = !state.menuActive;
    },
    CLOSE_MENU(state) {
      state.menuActive = false;
    },
    TOGGLE_PAGE_LOADER(state) {
      state.showPageLoader = !state.showPageLoader;
    },
    SET_ALL_ROOMS(state, rooms) {
      state.allRooms = rooms;
      localStorage.setItem("hmc-rooms", rooms);
    },
    SET_USER(state, user) {
      state.activeUser = user;
      let name = "";
      if (user.heb_name) name = user.heb_name;
      else if (user.name) name = user.name;
      state.activeUser["name"] = name;
      Vue.$cookies.set("hmc-active-user", JSON.stringify(user), {
        expires: "1D",
        path: "/",
        secure: process.env.NODE_ENV === "production",
        sameSite: "Strict"
      });
    },
    SET_USER_DOCTORS(state, doctors) {
      if (state.activeUser) state.activeUser.doctors = doctors;
      state.connectedCalendars = doctors;
    },
    SET_DOCTOR(state, doctor_id) {
      let all = state.connectedCalendars;

      let doctor = all.find(d => d.id == doctor_id);

      if (typeof doctor != "undefined") {
        localStorage.setItem("activeDoctor", JSON.stringify(doctor));
        state.activeDoctor = doctor;
      }

      const doctorFromUser = state.activeUser.doctors.find(
        user => user.id == state.activeDoctor.id
      );

      if (
        doctorFromUser &&
        doctorFromUser.policies &&
        (Object.keys(doctorFromUser.policies).length ||
          doctorFromUser.policies.length)
      ) {
        const policies = [];
        for (const key in doctorFromUser.policies) {
          const policy = doctorFromUser.policies[key];
          if (!policy.end_datetime) continue;

          const today = moment();
          let policyDate;
          if (
            policy.policy_number === "240186" &&
            doctorFromUser.total_exp_date
          ) {
            policyDate = moment(doctorFromUser.total_exp_date, "YYYY-MM-DD");
          } else {
            policyDate = moment(policy.end_datetime, "YYYY-MM-DD");
          }
          const thirtyDaysBefore = policyDate.clone().subtract(31, "days");
          const is30DaysBefore = thirtyDaysBefore.isBefore(today);
          if (is30DaysBefore) policies.push(policy);
        }
        state.activeDoctorPolicies = policies.length ? policies : null;
        return;
      } else if (doctorFromUser && doctorFromUser.total_exp_date) {
        const today = moment();
        const policyDate = moment(doctorFromUser.total_exp_date);
        const thirtyDaysBefore = policyDate.clone().subtract(31, "days");
        const is30DaysBefore = thirtyDaysBefore.isBefore(today);
        if (is30DaysBefore) {
          state.activeDoctorPolicies = [
            {
              policy_number: 0,
              policy_name: "אחריות מקצועית",
              end_datetime: doctorFromUser.total_exp_date
            }
          ];
          return;
        }
      }

      state.activeDoctorPolicies = null;
    },
    SET_DOCTOR_ROOMS(state, rooms) {
      state.doctorRooms = rooms;
    },
    SET_CAL_TYPE(state, type) {
      state.calendarType = type;
    },
    SET_PASSPORT(state, passport) {
      state.user_passport = passport;
    },
    SET_SURGERY_PATIENT(state, patient) {
      state.surg_patient = patient;
    },
    SET_SURGERY(state, object) {
      state.saveSurgery = object;
    },
    SET_CONNECTED_CALENDARS(state, doctors) {
      state.connectedCalendars = doctors;
    },
    SET_IS_CHANGE_APP(state, payload) {
      state.isChangeApp = payload;
    },
    SET_SHOW_SEARCH(state, payload) {
      state.isShowSearch = payload;
    },
    SET_IS_SURG_SCHEDULE(state, payload) {
      state.isSurgSchedule = payload;
    }
  },
  actions: {
    TOGGLE_MENU({ commit }) {
      commit("UPDATE_MENU_STATE");
    },
    CLOSE_MENU({ commit }) {
      commit("CLOSE_MENU");
    },
    TOGGLE_PAGE_LOADER({ commit }) {
      commit("TOGGLE_PAGE_LOADER");
    },
    SET_SURGERY_PATIENT({ commit }, patient) {
      commit("SET_SURGERY_PATIENT", patient);
      Vue.$cookies.set("hmc-surg-patient", JSON.stringify(patient), {
        expires: "1D",
        path: "/",
        secure: process.env.NODE_ENV === "production",
        sameSite: "Strict"
      });
    },
    SET_USER({ commit }, user) {
      commit("SET_USER", user);
      localStorage.setItem("hmc-user", JSON.stringify(user));
    },
    SET_USER_DOCTORS({ commit }, doctors) {
      commit("SET_USER_DOCTORS", doctors);
    },
    SET_DOCTOR({ commit }, doctor_id) {
      commit("SET_DOCTOR", doctor_id);
      localStorage.setItem("hmc-doctor", JSON.stringify(doctor_id));
    },
    SET_DOCTOR_ROOMS({ commit }, rooms) {
      commit("SET_DOCTOR_ROOMS", rooms);
    },
    CHANGE_CAL_TYPE({ commit }, type) {
      commit("SET_CAL_TYPE", type);
    },
    SET_SURGERY({ commit }, object) {
      localStorage.setItem("surgery", JSON.stringify(object));
      commit("SET_SURGERY", object);
    },
    SET_CONNECTCTED_CALENDARS({ commit }, doctors) {
      commit("SET_CONNECTED_CALENDARS", doctors);
    },
    SET_ALL_ROOMS({ commit }, rooms) {
      let arr = {};
      for (const el of rooms) {
        arr[el.value] = el;
      }
      commit("SET_ALL_ROOMS", arr);
    },
    LOGOUT({ commit }) {
      commit("SET_USER", {});
      commit("SET_USER_DOCTORS", null);
      Vue.$cookies.keys().forEach(cookie => Vue.$cookies.remove(cookie));
      for (const key in localStorage) {
        if (
          key != "init-desktop" &&
          key != "init-mobile" &&
          key != "after-login" &&
          key != "mobile-drag" &&
          !key.includes("intro")
        )
          localStorage.removeItem(key);
      }
      // localStorage.clear();
    },
    getAvailableTimes({ commit }, doctor_id) {}
  },
  modules: {
    Appoitments,
    UserProfile,
    TableDocs,
    Mobiscroll
  },
  getters: {
    isSurgSchedule: state => {
      return state.isSurgSchedule;
    },
    isShowSearch: state => {
      return state.isShowSearch;
    },
    selectedDayDesk: state => {
      return state.selectedDayDesk;
    },
    selectedViewDesk: state => {
      return state.selectedViewDesk;
    },
    isChangeApp: state => {
      return state.isChangeApp;
    },
    MENU_ACTIVE: state => {
      return state.menuActive;
    },
    doctors: state => {
      return state.connectedCalendars;

      return [];
    },
    activeDoctor: state => {
      return state.activeDoctor;
    },
    activeUser: state => {
      return state.activeUser;
    },
    calType: state => {
      return state.calendarType;
    },
    savedSurgery: state => {
      return state.saveSurgery;
    },
    allRooms: state => {
      return state.allRooms;
    },
    doctorRooms: state => {
      return state.doctorRooms;
    },
    connectedCalendars: state => {
      return state.connectedCalendars;
    },
    activeDoctorPolicies: state => {
      return state.activeDoctorPolicies;
    },
    getSurgStatusClass: state => type => {
      switch (type) {
        case "מאושר":
          return "status-green";
        case "לא מאושר":
          return "status-red";
        case "ממתין לאישור":
        case "ממתין לאישור מחודש":
        case "ממתין להפנייה":
          return "status-yellow";
        case "מבוטל":
          return "status-gray";
        default:
          return "status-gray";
      }
    },
    getAppScheduledBy: state => (type, isWhite) => {
      if (type === "site") {
        return {
          text: "אתר אינטרנט",
          image: isWhite
            ? "/assets/ScheduledBy/by-web-white.svg"
            : "/assets/ScheduledBy/by-web.svg"
        };
      }

      if (type === "manger") {
        return {
          text: "מנהל מערכת",
          image: isWhite
            ? "/assets/ScheduledBy/by-manager-white.svg"
            : "/assets/ScheduledBy/by-manager.svg"
        };
      }

      if (type === "doctor" || (type && type.includes("-app"))) {
        return {
          text: "מרפאת הרופא",
          image: isWhite
            ? "/assets/ScheduledBy/by-doctor-white.svg"
            : "/assets/ScheduledBy/by-doctor.svg"
        };
      }

      if (type === "int-call-center") {
        return {
          text: "המחלקה בינלאומית",
          image: isWhite
            ? "/assets/ScheduledBy/by-int-white.svg"
            : "/assets/ScheduledBy/by-int.svg"
        };
      }

      if (type === "call-center") {
        return {
          text: "מוקד המדיקל",
          image: isWhite
            ? "/assets/ScheduledBy/by-center-white.svg"
            : "/assets/ScheduledBy/by-center.svg"
        };
      }

      return null;
    },
    getAppBubbleStatus: state => (status, arrival_approval) => {
      if (status && (status == "arrived" || status == "הגיע")) {
        return {
          text: "הגיע",
          color: "background-color: #01a87a;",
          icon: "/assets/img/svg/ok-vector.svg",
          iconStyle: ""
        };
      } else if (status && (status == "no_show" || status == "לא הגיע")) {
        return {
          text: "לא הגיע",
          color: "background-color: #af011e;",
          icon: "/assets/img/svg/cancel-vector.svg",
          iconStyle: "width: 10px;"
        };
      } else if (arrival_approval && arrival_approval.includes("approved")) {
        return {
          text: "אושר הגעה",
          color: "background-color: #5581bd;",
          icon: "/assets/img/svg/ok-vector.svg",
          iconStyle: ""
        };
      }
      return null;
    },
    showIVF: state => {
      if (!state.activeUser?.doctors?.length || !state.activeDoctor) {
        return false;
      }

      const fullDoctorData = state.activeUser?.doctors.find(
        doctor => doctor.id == state.activeDoctor.id
      );

      const ivfSpecialties = [
        "IVF",
        "ivf",
        "הפרייה חוץ גופית",
        "הפריה חוץ גופית"
      ];

      const hasIvfSpecialty = value =>
        value && ivfSpecialties.some(ivf => value.includes(ivf));

      return (
        hasIvfSpecialty(fullDoctorData?.specialty) ||
        hasIvfSpecialty(fullDoctorData?.sub_specialty)
      );
    }
  }
});
